export default __webpack_public_path__ + "static/media/newuser.518d5d2c.svg";